const RESPONSE_PREVIEW_LIMIT = 500;

/**
 * Read a fetch Response body as text and parse JSON safely.
 * On parse failure, throws an error with a response preview for Sentry.
 *
 * @param {Response} response - the response to parse
 * @param {string} requestLabel - the label of the request
 * @returns {Promise<*>} - the parsed response
 */
export default async function parseJsonResponse(response, requestLabel) {
    const text = await response.text();

    try {
        return JSON.parse(text);
    } catch (parseError) {
        const error = new Error(
            `${response.status} - Non-JSON response from ${requestLabel}`
        );
        error.name = 'NonJsonResponseError';
        error.cause = parseError;
        error.requestLabel = requestLabel;
        error.responseUrl = response.url;
        error.responseStatus = response.status;
        error.contentType = response.headers.get('content-type');
        error.responsePreview = text.slice(0, RESPONSE_PREVIEW_LIMIT);

        throw error;
    }
}
